/* eslint-disable jsx-a11y/img-redundant-alt */
// import React from "react";

// const Portfolio = () => {
//   return (
//     <section className="rs-portfolio-area section-space-top rs-portfolio-one rs-swiper">
//       <div className="container">
//         <div className="row g-5 section-title-space align-items-end">
//           <div className="col-xxl-7 col-xl-8 col-lg-8">
//             <div className="rs-section-title-wrapper">
//               <span className="rs-section-subtitle has-theme-orange justify-content-start">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="11"
//                   height="15"
//                   viewBox="0 0 11 15"
//                   fill="none"
//                 >
//                   <path
//                     d="M3.14286 10L0 15L8.78104e-07 0L3.14286 5V10Z"
//                     fill="#EA5501"
//                   ></path>
//                   <path
//                     fillRule="evenodd"
//                     clipRule="evenodd"
//                     d="M6.28571 10L3.14286 15L3.14286 10L4.71428 7.5L3.14286 5L3.14286 0L6.28571 5L6.28571 10ZM6.28571 10L7.85714 7.5L6.28571 5V0L11 7.5L6.28571 15V10Z"
//                     fill="#EA5501"
//                   ></path>
//                 </svg>
//                 Recent Work
//               </span>
//               <h2 className="rs-section-title">Explore Large-Scale Projects</h2>
//             </div>
//           </div>
//           <div className="col-xxl-5 col-xl-4 col-lg-4">
//             {/* <!-- If we need navigation buttons --> */}
//             <div className="rs-portfolio-navigation">
//               <button className="swiper-button-prev rs-swiper-btn has-bg-light">
//                 <i className="fa-regular fa-arrow-left"></i>
//               </button>
//               <button className="swiper-button-next rs-swiper-btn has-bg-light">
//                 <i className="fa-regular fa-arrow-right"></i>
//               </button>
//             </div>
//           </div>
//         </div>
//         <div className="row">
//           <div className="col-xl-12">
//             <div className="rs-portfolio-slider-wrapper">
//               <div
//                 className="swiper has-space"
//                 data-clone-slides="false"
//                 data-loop="true"
//                 data-speed="1500"
//                 data-autoplay="true"
//                 data-dots-dynamic="false"
//                 data-hover-pause="true"
//                 data-effect="false"
//                 data-delay="2500"
//                 data-item="4"
//                 data-item-xl="3"
//                 data-item-lg="3"
//                 data-item-md="2"
//                 data-item-sm="1"
//                 data-item-xs="1"
//                 data-item-mobile="1"
//                 data-margin="30"
//                 data-margin-xl="30"
//               >
//                 <div className="swiper-wrapper">
//                   <div className="swiper-slide">
//                     <div className="rs-portfolio-item">
//                       <div className="rs-portfolio-thumb">
//                         <img
//                           src="assets/images/portfolio/portfolio-thumb-01.png"
//                           alt="image"
//                         />
//                       </div>
//                       <div className="rs-portfolio-content">
//                         <div className="rs-portfolio-tag">
//                           <Link to="portfolio-details.html">Company</Link>
//                         </div>
//                         <h4 className="rs-portfolio-title underline has-white">
//                           <Link to="portfolio-details.html">Metal Industry</Link>
//                         </h4>
//                         <div className="rs-portfolio-btn">
//                           <Link
//                             to="portfolio-details.html"
//                             className="rs-btn has-theme-orange has-circle has-icon"
//                           >
//                             <span className="icon-box">
//                               <svg
//                                 className="icon-first"
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 viewBox="0 0 32 32"
//                               >
//                                 <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
//                               </svg>
//                               <svg
//                                 className="icon-second"
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 viewBox="0 0 32 32"
//                               >
//                                 <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
//                               </svg>
//                             </span>
//                           </Link>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="swiper-slide">
//                     <div className="rs-portfolio-item">
//                       <div className="rs-portfolio-thumb has-clip-path">
//                         <img
//                           src="assets/images/portfolio/portfolio-thumb-02.png"
//                           alt="image"
//                         />
//                       </div>
//                       <div className="rs-portfolio-content">
//                         <div className="rs-portfolio-tag">
//                           <Link to="portfolio-details.html">Company</Link>
//                         </div>
//                         <h4 className="rs-portfolio-title underline has-white">
//                           <Link to="portfolio-details.html">Metal Industry</Link>
//                         </h4>
//                         <div className="rs-portfolio-btn">
//                           <Link
//                             to="portfolio-details.html"
//                             className="rs-btn has-theme-orange has-circle has-icon"
//                           >
//                             <span className="icon-box">
//                               <svg
//                                 className="icon-first"
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 viewBox="0 0 32 32"
//                               >
//                                 <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
//                               </svg>
//                               <svg
//                                 className="icon-second"
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 viewBox="0 0 32 32"
//                               >
//                                 <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
//                               </svg>
//                             </span>
//                           </Link>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="swiper-slide">
//                     <div className="rs-portfolio-item">
//                       <div className="rs-portfolio-thumb has-clip-path">
//                         <img
//                           src="assets/images/portfolio/portfolio-thumb-03.png"
//                           alt="image"
//                         />
//                       </div>
//                       <div className="rs-portfolio-content">
//                         <div className="rs-portfolio-tag">
//                           <Link to="portfolio-details.html">Company</Link>
//                         </div>
//                         <h4 className="rs-portfolio-title underline has-white">
//                           <Link to="portfolio-details.html">Manufacture</Link>
//                         </h4>
//                         <div className="rs-portfolio-btn">
//                           <Link
//                             to="portfolio-details.html"
//                             className="rs-btn has-theme-orange has-circle has-icon"
//                           >
//                             <span className="icon-box">
//                               <svg
//                                 className="icon-first"
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 viewBox="0 0 32 32"
//                               >
//                                 <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
//                               </svg>
//                               <svg
//                                 className="icon-second"
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 viewBox="0 0 32 32"
//                               >
//                                 <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
//                               </svg>
//                             </span>
//                           </Link>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="swiper-slide">
//                     <div className="rs-portfolio-item">
//                       <div className="rs-portfolio-thumb has-clip-path">
//                         <img
//                           src="assets/images/portfolio/portfolio-thumb-04.png"
//                           alt="image"
//                         />
//                       </div>
//                       <div className="rs-portfolio-content">
//                         <div className="rs-portfolio-tag">
//                           <Link to="portfolio-details.html">Company</Link>
//                         </div>
//                         <h4 className="rs-portfolio-title underline has-white">
//                           <Link to="portfolio-details.html">
//                             Oil &amp; Gas Factory
//                           </Link>
//                         </h4>
//                         <div className="rs-portfolio-btn">
//                           <Link
//                             to="portfolio-details.html"
//                             className="rs-btn has-theme-orange has-circle has-icon"
//                           >
//                             <span className="icon-box">
//                               <svg
//                                 className="icon-first"
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 viewBox="0 0 32 32"
//                               >
//                                 <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
//                               </svg>
//                               <svg
//                                 className="icon-second"
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 viewBox="0 0 32 32"
//                               >
//                                 <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
//                               </svg>
//                             </span>
//                           </Link>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Portfolio;

// import React from "react";
// import styled from "styled-components";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Autoplay } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/navigation";

// const portfolioData = [
//   {
//     id: 1,
//     img: "/assets/images/portfolio/portfolio-thumb-01.png",
//     tag: "Company",
//     title: "Metal Industry",
//     link: "portfolio-details.html",
//   },
//   {
//     id: 2,
//     img: "/assets/images/portfolio/portfolio-thumb-02.png",
//     tag: "Company",
//     title: "Metal Industry",
//     link: "portfolio-details.html",
//   },
//   {
//     id: 3,
//     img: "/assets/images/portfolio/portfolio-thumb-03.png",
//     tag: "Company",
//     title: "Manufacture",
//     link: "portfolio-details.html",
//   },
//   {
//     id: 4,
//     img: "/assets/images/portfolio/portfolio-thumb-04.png",
//     tag: "Company",
//     title: "Oil & Gas Factory",
//     link: "portfolio-details.html",
//   },
//   {
//     id: 5,
//     img: "/assets/images/portfolio/portfolio-thumb-02.png",
//     tag: "Company",
//     title: "Metal Industry",
//     link: "portfolio-details.html",
//   },
// ];

// const Portfolio = () => {
//   return (
//     <section className="rs-portfolio-area section-space-top rs-portfolio-one rs-swiper">
//       <Wrapper>
//         <div className="container">
//           <div className="row g-5 section-title-space align-items-end">
//             <div className="col-xxl-7 col-xl-8 col-lg-8">
//               <div className="rs-section-title-wrapper">
//                 <span className="rs-section-subtitle has-theme-orange justify-content-start">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="11"
//                     height="15"
//                     viewBox="0 0 11 15"
//                     fill="none"
//                   >
//                     <path
//                       d="M3.14286 10L0 15L8.78104e-07 0L3.14286 5V10Z"
//                       fill="#EA5501"
//                     ></path>
//                     <path
//                       fillRule="evenodd"
//                       clipRule="evenodd"
//                       d="M6.28571 10L3.14286 15L3.14286 10L4.71428 7.5L3.14286 5L3.14286 0L6.28571 5L6.28571 10ZM6.28571 10L7.85714 7.5L6.28571 5V0L11 7.5L6.28571 15V10Z"
//                       fill="#EA5501"
//                     ></path>
//                   </svg>
//                   Recent Work
//                 </span>
//                 <h2 className="rs-section-title">
//                   Explore Large-Scale Projects
//                 </h2>
//               </div>
//             </div>
//             <div className="col-xxl-5 col-xl-4 col-lg-4">
//               <div className="rs-portfolio-navigation">
//                 <button className="swiper-button-prev rs-swiper-btn has-bg-light">
//                   <i className="fa-regular fa-arrow-left"></i>
//                 </button>
//                 <button className="swiper-button-next rs-swiper-btn has-bg-light">
//                   <i className="fa-regular fa-arrow-right"></i>
//                 </button>
//               </div>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-xl-12">
//               <div className="rs-portfolio-slider-wrapper">
//                 <Swiper
//                   modules={[Navigation, Autoplay]}
//                   navigation={{
//                     nextEl: ".swiper-button-next",
//                     prevEl: ".swiper-button-prev",
//                   }}
//                   autoplay={{ delay: 2500, disableOnInteraction: false }}
//                   loop={true}
//                   speed={1500}
//                   spaceBetween={30}
//                   slidesPerView={4}
//                   breakpoints={{
//                     0: { slidesPerView: 1 },
//                     576: { slidesPerView: 1 },
//                     768: { slidesPerView: 2 },
//                     992: { slidesPerView: 3 },
//                     1200: { slidesPerView: 3 },
//                     1400: { slidesPerView: 4 },
//                   }}
//                 >
//                   {portfolioData.map((item) => (
//                     <SwiperSlide key={item.id}>
//                       <div className="rs-portfolio-item">
//                         <div
//                           className={`rs-portfolio-thumb ${item.id !== 1 ? "has-clip-path" : ""}`}
//                         >
//                           <img src={item.img} alt={item.title} />
//                         </div>
//                         <div className="rs-portfolio-content">
//                           <div className="rs-portfolio-tag">
//                             <Link to={item.link}>{item.tag}</Link>
//                           </div>
//                           <h4 className="rs-portfolio-title underline has-white">
//                             <Link to={item.link}>{item.title}</Link>
//                           </h4>
//                           <div className="rs-portfolio-btn">
//                             <Link
//                               to={item.link}
//                               className="rs-btn has-theme-orange has-circle has-icon"
//                             >
//                               <span className="icon-box">
//                                 <svg
//                                   className="icon-first"
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   viewBox="0 0 32 32"
//                                 >
//                                   <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
//                                 </svg>
//                                 <svg
//                                   className="icon-second"
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   viewBox="0 0 32 32"
//                                 >
//                                   <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
//                                 </svg>
//                               </span>
//                             </Link>
//                           </div>
//                         </div>
//                       </div>
//                     </SwiperSlide>
//                   ))}
//                 </Swiper>
//               </div>
//             </div>
//           </div>
//         </div>
//       </Wrapper>
//     </section>
//   );
// };

// const Wrapper = styled.section``;

// export default Portfolio;

import React, { useRef } from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";

const portfolioData = [
  {
    id: 1,
    img: "/assets/images/portfolio/portfolio-thumb-01.png",
    tag: "Company",
    title: "Metal Industry",
    link: "portfolio-details.html",
  },
  {
    id: 2,
    img: "/assets/images/portfolio/portfolio-thumb-02.png",
    tag: "Company",
    title: "Metal Industry",
    link: "portfolio-details.html",
  },
  {
    id: 3,
    img: "/assets/images/portfolio/portfolio-thumb-03.png",
    tag: "Company",
    title: "Manufacture",
    link: "portfolio-details.html",
  },
  {
    id: 4,
    img: "/assets/images/portfolio/portfolio-thumb-04.png",
    tag: "Company",
    title: "Oil & Gas Factory",
    link: "portfolio-details.html",
  },
  {
    id: 5,
    img: "/assets/images/portfolio/portfolio-thumb-02.png",
    tag: "Company",
    title: "Metal Industry",
    link: "portfolio-details.html",
  },
];

const Portfolio = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <section className="rs-portfolio-area section-space-top rs-portfolio-one rs-swiper">
      <Wrapper>
        <div className="container">
          {/* Title */}
          <div className="row g-5 section-title-space align-items-end">
            <div className="col-lg-8">
              <div className="rs-section-title-wrapper">
                <span className="rs-section-subtitle has-theme-orange">
                  Recent Work
                </span>
                <h2 className="rs-section-title">
                  Explore Large-Scale Projects
                </h2>
              </div>
            </div>

            {/* Navigation */}
            <div className="col-lg-4">
              <div className="rs-portfolio-navigation">
                <button ref={prevRef} className="rs-swiper-btn has-bg-light">
                  <i className="fa fa-arrow-left"></i>
                </button>

                <button ref={nextRef} className="rs-swiper-btn has-bg-light">
                  <i className="fa fa-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Slider */}
          <Swiper
            modules={[Navigation, Autoplay]}
            loop={true}
            speed={1500}
            spaceBetween={30}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            slidesPerView={4}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1400: { slidesPerView: 4 },
            }}
          >
            {portfolioData.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="rs-portfolio-item">
                  <div className="rs-portfolio-thumb">
                    <img src={item.img} alt={item.title} />
                  </div>

                  <div className="rs-portfolio-content">
                    <div className="rs-portfolio-tag">
                      <Link to={item.link}>{item.tag}</Link>
                    </div>

                    <h4 className="rs-portfolio-title">
                      <Link to={item.link}>{item.title}</Link>
                    </h4>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Wrapper>
    </section>
  );
};

const Wrapper = styled.section``;

export default Portfolio;
